import { html, render } from "lit-html";
import { SharingDialog } from "./SharingDialog";
import { connect } from "../connect-with-dialog";
import { translate } from "../../../shared/l10n/translate";

class SharingButton extends HTMLElement {
	constructor() {
		super();
		render(html`${translate("hotel_stage_sharing")}`, this);
	}
}
customElements.define(
	"esc-sharing-button",
	connect(SharingDialog, SharingButton),
);
